import dailyHydratingFaceCreamImage from '../../../../assets/img/buy-again/daily-hydrating-face-cream.png';
import soothingCleanserImage from '../../../../assets/img/buy-again/soothing-cleanser.png';
import vitaminCSerumImage from '../../../../assets/img/buy-again/vitamin-c-serum.png';
import type { OrderItem } from '../services/buy-again';

export const PLACEHOLDER_ORDER_ITEMS: OrderItem[] = [
  {
    catalogItemId: 'placeholder-item-1',
    productName: 'Vitamin C Serum',
    formattedPrice: '$45.99',
    imageUrl: vitaminCSerumImage,
  },
  {
    catalogItemId: 'placeholder-item-2',
    productName: 'Soothing Cleanser',
    formattedPrice: '$25.00',
    imageUrl: soothingCleanserImage,
  },
  {
    catalogItemId: 'placeholder-item-3',
    productName: 'Daily Hydrating Face Cream',
    formattedPrice: '$55.69',
    imageUrl: dailyHydratingFaceCreamImage,
  },
];
